import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { TextField, Grid2 as Grid, Button, Typography } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

const CustomerSearch = ({ filter, handleSubmit }) => {
    const { t } = useTranslation();
    const { control, handleSubmit: handleFormSubmit, reset } = useForm();

    const onSubmit = (data) => {
        handleSubmit(data);
    };

    const resetForm = () => {
        reset({
            name: '',
        });
        handleSubmit({});
    };

    return (
        <form onSubmit={handleFormSubmit(onSubmit)}>
            <Typography variant="h4" component="h4" sx={{ px: 2, pt: 2 }}>{t('Search|noun')}</Typography>
            <Grid container spacing={2} sx={{ px: 2, pb: 3 }}>
                <Grid size={{ xs: 12, sm: 2 }}>
                    <Controller
                        name="name"
                        control={control}
                        defaultValue={filter.name ? filter.name.replace(/^%|%$/g, '') : ''}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                InputProps={{ type: 'search' }}
                                label={t('Name')}
                                variant="standard"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <Button type="submit" variant="contained" size="small" startIcon={<SearchIcon />} sx={{ mr: 1 }}>
                        {t('Search|verb')}
                    </Button>
                    <Button variant="outlined" size="small" onClick={resetForm} startIcon={<ClearIcon />}>
                        {t('Clear')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default CustomerSearch;
